import React from "react";
import useIsMobile from "../hooks/useIsMobile";

const Footer = () => {
  const isMobile = useIsMobile();
  if (isMobile) return null;
  return (
    <footer className="app-footer">
      <a
        href="https://www.instagram.com/app.smartdx"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
        title="Instagram"
        aria-label="Instagram"
      >
        <img
          src="/instagram.png"
          alt="Instagram"
          className="footer-icon"
        />
      </a>
      <a
        href="https://www.tiktok.com/@app.smartdx"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
        title="TikTok"
        aria-label="TikTok"
      >
        <img
          src="/tiktok.png"
          alt="TikTok"
          className="footer-icon"
        />
      </a>
      <a
        href="mailto:sebastian@smardx.com"
        className="footer-link"
        title="Mail"
        aria-label="Mail"
      >
        <img
          src="/mail.png"
          alt="Mail"
          className="footer-icon"
        />
      </a>
      <style>
        {`
          .app-footer {
            position: fixed;
            z-index: 1;
            bottom: 10px;
            right: 14px;
            display: flex;
            gap: 14px;
            align-items: center;
            background: transparent;
            padding: 0;
            margin: 0;
          }

          .footer-link {
            color: var(--text-faint);
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 22px;
            height: 22px;
            transition: color 0.15s, transform 0.15s, opacity 0.15s;
            opacity: 0.7;
          }

          .footer-link:hover {
            color: var(--color-info);
            opacity: 1;
            transform: translateY(-2px);
          }

          .footer-link:focus-visible {
            color: var(--color-info);
            opacity: 1;
            outline: 2px solid rgba(130, 177, 255, 0.5);
            outline-offset: 4px;
            border-radius: 4px;
          }

          .footer-icon {
            width: 18px;
            height: 18px;
          }

          @media (max-width: 600px) {
            .app-footer {
              bottom: 12px;
              right: 12px;
              gap: 18px;
            }

            .footer-link {
              width: 28px;
              height: 28px;
              opacity: 0.85;
            }

            .footer-icon {
              width: 22px;
              height: 22px;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
